module.exports = __webpack_public_path__ + "a17d279f/img/share-action-icon.9c12578c.svg";